import { ParagraphBlock } from '@/types';
import { FilterOption, InlineEditor, VariableOption } from '../InlineEditor';

interface ParagraphBlockViewProps {
  block: ParagraphBlock;
  onChange: (next: ParagraphBlock) => void;
  variables: VariableOption[];
  filterOptions: FilterOption[];
}

export function ParagraphBlockView({
  block,
  onChange,
  variables,
  filterOptions,
}: Readonly<ParagraphBlockViewProps>) {
  return (
    <InlineEditor
      value={block.content}
      onChange={(content) => onChange({ ...block, content })}
      variables={variables}
      filterOptions={filterOptions}
      flavour="paragraph"
      placeholder="Write here — type @ to insert a variable, click a variable chip to add filters"
      ariaLabel="Paragraph content"
    />
  );
}
